import { writable } from 'svelte/store';

// ═══ ОБЩАЯ ЛЕНТА СООБЩЕНИЙ ХУДА ═══
// Объявления сервера и обычные уведомления показываются одним потоком в блоке
// «Уведомления»: один размер, одно место, очередь вместо наложения. Отличается
// только оформление — объявление идёт первым, в золотых цветах, и висит дольше.
// Здесь лежит текущее объявление: { kick, head, text } или null.
export const feedAnnounce = writable(null);

/* Поднятие уровня показывается в той же верхней ленте, что объявления:
   это событие «главное», ему нужно висеть дольше обычного уведомления. */
export const feedLevel = writable(null);
